// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"242":"76273b84","267":"3cf4bb82","320":"76273b84"}[chunkId] + ".chunk.css");